import { IconName } from "Components/UI"
import { NotificationActionEnum } from "../Notification/INotification"

export interface IValuePreferencesMenuItem {
  Id: string
  Title?: string
  ValueLeft?: boolean
  ValueRight?: boolean
  TitleSwitch?: string
  DescriptionSwitch?: string
  ParamSwitch?: string
  ParamRequestSwitch?: string
  ValueSwitch?: boolean
  ValueSwitchDisabled?: boolean
  TitleSelect?: string
  DescriptionSelect?: string
  ParamSelect?: string
  ParamRequestSelect?: string
  ValueSelect?: string
  ValueSelectDisabled?: boolean
  SelectType?: TypeSelectNotificationOptionsEnum
  isPeriodicity?: boolean
  Order: number
}

export interface IPreferencesMenuItem {
  Id: string
  Title: string
  Order: number
  Type: PreferencesMenuItemTypeEnum
  Items: IValuePreferencesMenuItem[]
}

export enum PreferencesMenuItemTypeEnum {
  Table,
  CheckAndSelect,
  CheckAndSelectTable,
  SelectTable,
}

export interface IPreferencesMenuItemTitle {
  Id: string
  Title: string
  Order: number
  Items: IPreferencesMenuItem[]
}

export interface IPreferencesMenu {
  Id: string
  Type: PreferencesMenuTypeEnum
  IsDisabled: boolean
  Items: IPreferencesMenuItemTitle[]
}

export enum PreferencesMenuTypeEnum {
  Notifications,
  NotificationByEmail,
  ReportByEmail,
  Language,
  Accessibility,
  Interface,
}

export interface IStateRequestUpdate {
  Type: PreferencesMenuTypeEnum
  itemParentId: string
  itemChildrenId: string
  valueId: string
  value: boolean | string
  isLeft?: boolean
  selectType?: string
}

export enum PreferencesActionEnum {
  Periodicity = 100,
}

export type TypeSelectNotificationOptionsEnum = NotificationActionEnum | PreferencesActionEnum

export const TitlePreferencesMenuByType: Record<PreferencesMenuTypeEnum, string> = {
  [PreferencesMenuTypeEnum.Notifications]: 'Notificações',
  [PreferencesMenuTypeEnum.NotificationByEmail]: 'Notificações por E-mail',
  [PreferencesMenuTypeEnum.ReportByEmail]: 'Relatórios por E-mail',
  [PreferencesMenuTypeEnum.Language]: 'Idioma e região',
  [PreferencesMenuTypeEnum.Accessibility]: 'Acessibilidade',
  [PreferencesMenuTypeEnum.Interface]: 'Interface',
}

export const DescriptionPreferencesMenuByType: Record<PreferencesMenuTypeEnum, string> = {
  [PreferencesMenuTypeEnum.Notifications]: 'Notificações da Central',
  [PreferencesMenuTypeEnum.NotificationByEmail]: 'Notificações por E-mail',
  [PreferencesMenuTypeEnum.ReportByEmail]: 'Relatórios por E-mail',
  [PreferencesMenuTypeEnum.Language]: 'Idioma e região',
  [PreferencesMenuTypeEnum.Accessibility]: 'Acessibilidade',
  [PreferencesMenuTypeEnum.Interface]: 'Interface',
}

export const IconPreferencesMenuByType: Record<PreferencesMenuTypeEnum, IconName> = {
  [PreferencesMenuTypeEnum.Notifications]: 'bell',
  [PreferencesMenuTypeEnum.NotificationByEmail]: 'email',
  [PreferencesMenuTypeEnum.ReportByEmail]: 'reportMail',
  [PreferencesMenuTypeEnum.Language]: 'globe',
  [PreferencesMenuTypeEnum.Accessibility]: 'person',
  [PreferencesMenuTypeEnum.Interface]: 'listDetailVision',
}
